import { render, staticRenderFns } from "./fcIndex.vue?vue&type=template&id=f6211808&"
import script from "./fcIndex.vue?vue&type=script&lang=js&"
export * from "./fcIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports